import { ProgressSpinner } from "primereact/progressspinner";
import React, { useEffect, useState } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import Alert from "../../../Common/Alert";
import Http from "../../../Common/Http";
import IsLogin from "../../../Common/IsLogin";

const Show = () => {
  const [receiveData, setReceiveData] = useState({});
  const { id } = useParams();
  const [alert, setAlert] = useState(null);
  const location = useLocation();
  const [loading, setLoading] = useState(true);

  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await Http.get("/damage/" + id);
      setReceiveData(res.data);
    } catch (error) {
      console.error("Fetch error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [id]);

  const showAlert = (message, type) => {
    setAlert({
      message: message,
      type: type,
    });
    setTimeout(() => {
      setAlert(null);
    }, 4000);
  };

  useEffect(() => {
    if (!location.state) {
      return;
    }
    showAlert(location.state.message, location.state.type);
  }, [location]);

  return (
    <div>
      <IsLogin />
      <div className="am-mainpanel">
        <div className="am-pagetitle">
          <h5 className="am-title">Return Details</h5>
          <Link to="/damage" className="btn btn-secondary">
            <i className="fa fa-arrow-left mg-r-6"></i>Back
          </Link>
        </div>

        <div className="am-pagebody">
          <Alert alert={alert} />
          <div className="card pd-20 pd-sm-40">
            {loading ? (
              <div className="text-center">
                <ProgressSpinner />
              </div>
            ) : (
              <div className="col-lg-12 col-md-12 col-sm-12 col-12 padding">
                <div className="card">
                  <div className="card-body">
                    <div className="row mb-4">
                      <div className="col-sm-12">
                        <h5 className="mb-3">Return Information:</h5>
                        <div>
                          <strong>Damage No:</strong> {receiveData.damage_no}
                        </div>
                        <div>
                          <strong>Date:</strong> {receiveData.date}
                        </div>
                        <div>
                          <strong>Time:</strong> {receiveData.time}
                        </div>
                        <div>
                          <strong>Status:</strong> {receiveData.status || "N/A"}
                        </div>
                        <div>
                          <strong>Notes:</strong> {receiveData.notes || "N/A"}
                        </div>
                        <div>
                          <strong>To:</strong>{" "}
                          {receiveData.to_department_user
                            ? receiveData.to_department_user.name
                            : "N/A"}
                        </div>
                        <div>
                          <strong>Created By:</strong>{" "}
                          {receiveData.created_by
                            ? receiveData.created_by.name
                            : "N/A"}
                        </div>
                      </div>
                    </div>

                    {receiveData.items && receiveData.items.length > 0 && (
                      <>
                        <h5 className="mb-3">Damage Items</h5>
                        <div className="table-responsive-sm">
                          <table className="table table-striped table-bordered">
                            <thead>
                              <tr>
                                <th className="center">#</th>
                                <th>Product</th>
                                <th className="text-right">Qty</th>
                                <th className="text-right">Unit</th>
                                <th>Remarks</th>
                              </tr>
                            </thead>
                            <tbody>
                              {receiveData.items.map((item, index) => (
                                <tr key={item.id || index}>
                                  <td className="center">{index + 1}</td>
                                  <td className="left strong">
                                    {item.product_group ? item.product_group.id : ""} - {item.product_group ? item.product_group.name : ""}
                                  </td>
                                  <td className="text-right">{item.qty}</td>
                                  <td className="text-right">{item.product?.unit?.name || item?.product_group?.unit?.name || "N/A"}</td>
                                  <td>{item.remarks || "-"}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </>
                    )}

                    <div className="row mt-4">
                      <div className="col-sm-12 text-center">
                        <Link to="/damage" className="btn btn-secondary">
                          <i className="fa fa-arrow-left mg-r-6"></i>Back to
                          List
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Show;
